export const tenantsKeys = {
  all: ['tenants'] as const,
  lists: () => [...tenantsKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...tenantsKeys.lists(), filters] as const,
  details: () => [...tenantsKeys.all, 'detail'] as const,
  detail: (id: string) => [...tenantsKeys.details(), id] as const,
  members: (tenantId: string) => [...tenantsKeys.all, 'members', tenantId] as const,
  memberList: (tenantId: string, page: number, pageSize: number) =>
    [...tenantsKeys.members(tenantId), page, pageSize] as const,
};
